import Splide from '@splidejs/splide'
import sliderConfig from '../../config/sliders.js'
import { LuminousGallery } from 'luminous-lightbox'
import ProductFilters from './productFilters.js'
import QuoteRequest from './quote.js'
import _ from 'lodash'

class FrontPages {
    constructor() {
        this.initProductImagesSlider()
        this.initTabsSwitch()
        this.initProductFilters()
        this.initProductsSlider()
        new QuoteRequest()
    }

    /**
     * Initialize product images slider
     *
     * @return void
     */
    initProductImagesSlider() {
        let productHeaders = document.querySelectorAll('.kpc-product-header')

        // Find all ProductHeaders
        productHeaders.forEach(function (header) {
            let primarySliderEl = null,
                secondarySliderEl = null

            // if thumbnailsLeft
            if (header.classList.contains('thumbnailsLeft')) {
                primarySliderEl = header.querySelector('.kpc-product-slider.primary')
                secondarySliderEl = header.querySelector('.kpc-product-slider.secondary')

                if (!_.isNil(primarySliderEl) && !_.isNil(secondarySliderEl)) {

                    // Create sliders
                    let pry_slider = new Splide(
                        primarySliderEl,
                        sliderConfig.thumbnailsLeft.primary
                    )
                    let snd_slider = new Splide(
                        secondarySliderEl,
                        sliderConfig.thumbnailsLeft.secondary
                    )

                    // Mount them
                    snd_slider.mount()
                    pry_slider.sync(snd_slider)
                    pry_slider.mount()
                }
            }

            if (header.classList.contains('thumbnailsBottom')) {
                primarySliderEl = header.querySelector('.kpc-product-slider.primary')
                secondarySliderEl = header.querySelector('.kpc-product-slider.secondary')

                if (!_.isNil(primarySliderEl)) {
                    // Create sliders
                    let snd_slider = null
                    let pry_slider = new Splide(
                        primarySliderEl,
                        sliderConfig.thumbnailsBottom.primary
                    )

                    if (!_.isNil(secondarySliderEl)) {
                        snd_slider = new Splide(
                            secondarySliderEl,
                            sliderConfig.thumbnailsBottom.secondary
                        )
                    }

                    // Mount them
                    if (!_.isNil(secondarySliderEl)) {
                        snd_slider.mount()
                        pry_slider.sync(snd_slider)
                    }

                    pry_slider.mount()
                }
            }

            if (header.classList.contains('simple')) {
                primarySliderEl = header.querySelector('.kpc-product-slider.primary')

                if (!_.isNil(primarySliderEl)) {
                    // Create slider
                    let pry_slider = new Splide(primarySliderEl, sliderConfig.simple.primary)
                    // Mount
                    pry_slider.mount()
                }
            }

            // Enable Lightbox
            let imgLboxEl = document.querySelectorAll('.kpc-product-lightbox'),
                lboxOpt = {
                    sourceAttribute: 'data-ke-pr-lbox-src',
                    showCloseButton: true,
                },
                lboxGalleryOpts = {
                    arrowNavigation: true,
                }

            const lboxGallery = new LuminousGallery(imgLboxEl, lboxGalleryOpts, lboxOpt)
        })
    }

    initTabsSwitch() {
        let tabsContainerEl = document.querySelector('.kpc-product-contents .kpc-tabs'),
            activeTabClassName = 'kpc-tab-list-active',
            activeCtntClassName = 'kpc-active-area'

        if (!!tabsContainerEl) {
            let tabsEl = tabsContainerEl.querySelectorAll('.kpc-tab-list-item')

            if (tabsEl && tabsEl.length > 0) {
                for (let thisTab of tabsEl) {
                    thisTab.addEventListener('click', (ev) => {
                        event.preventDefault()
                        let tabContentID = ev.target.dataset.tabTarget,
                            activeTabsEl = tabsContainerEl.querySelectorAll(
                                '.kpc-tab-list-item.' + activeTabClassName
                            ),
                            activeCtntEl = tabsContainerEl.querySelectorAll(
                                '.kpc-product-content-area.' + activeCtntClassName
                            )

                        if (tabContentID) {
                            let tabContentEl = document.querySelector('#' + tabContentID)

                            // Remove actual active class
                            if (activeTabsEl && activeTabsEl.length > 0) {
                                for (let aTab of activeTabsEl) {
                                    aTab.classList.remove(activeTabClassName)
                                }
                            }
                            if (activeCtntEl && activeCtntEl.length > 0) {
                                for (let aCtnt of activeCtntEl) {
                                    aCtnt.classList.remove(activeCtntClassName)
                                }
                            }

                            // Add class active class
                            if (tabContentEl) {
                                ev.target.classList.add(activeTabClassName)
                                tabContentEl.classList.add(activeCtntClassName)
                            }
                        }
                    })
                }
            }
        }
    }

    initProductFilters() {
        let filtersEl = document.getElementById('kpc-filters')

        if (!!filtersEl) {
            new ProductFilters()
        }
    }

    initProductsSlider() {
        let productSliders = document.querySelectorAll('.kpc-products-slider')

        // Find all ProductHeaders
        productSliders.forEach(function (block) {
            let sliderEl = block.querySelector('.kpc-slider'),
                sliderParams = sliderConfig.productsSlider,
                attrPerPage = sliderEl.dataset.kpcPerpage

            if (!_.isEmpty(attrPerPage)) {
                sliderParams.perPage = parseInt(attrPerPage)
            }

            // Create slider
            let prSlider = new Splide(sliderEl, sliderParams)

            // Mount
            prSlider.mount()
        })
    }
}

window.addEventListener('load', () => {
    global.ke_pc_front_class = new FrontPages()
})
